var lib_core = require('lib-core');
var cio_datamodel = require('./index.js');

var generateClassDescription = function(klass) {
	var class_description = {};
	var obj = new klass();
	if (!obj.collections) return {};	// TODO: this hack needs to be removed!! (now necessary for versioned coord)
	obj.collections.forEach(function(name, member){
		// if (member.isPersistent()){
			class_description[name] = {
				type: member.getType(),
				owner: member.isOwner()
			}
		// }

	});
	return class_description;
};

var generateDatamodelDescription = function() {
	var datamodel_description = {
		datamodel_version: cio_datamodel.datamodel_version,
		classes: {}
	};
	for(var name in cio_datamodel) {
		var klass = cio_datamodel[name];
		if(klass && klass.$class)	//if it is a datamodel class
			datamodel_description.classes[klass.$class] = generateClassDescription(klass);
	}
	return datamodel_description;
};

module.exports = generateDatamodelDescription;
